const styles = {
  // NAVIGATION BAR
  navbar: {
    gridArea: 'navbar',
    background: 'url(assets/images/background-header.png)',
    backgroundColor: '#7F1431',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    backrgoundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    marginBottom: '10px',
  },
  nav_text: {
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    textTransform: 'uppercase',
  },
  nav_title: {
    fontSize: '30px',
    // marginRight: '10px',
    color: '#FFFFFF',
    fontFamily: 'League Gothic',
  },
  nav_anchor: {
    paddingLeft: '20px',
    '& a': {
      cursor: 'pointer',
      textDecoration: 'none',
      color: '#aaa',
    },
    '& :hover': {
      color: '#fff',
    },
  },
  nav_anchorselected: {
    marginLeft: '20px',
    // borderBottom: '3px solid #fff',
  },
  nav_title_mob: {
    fontSize: '18px',
    marginRight: '10px',
  },
  hamburger: {
    cursor: 'pointer',
    alignSelf: 'center',
    width: '20px',
  },
  hamb: {
    height: 2,
    backgroundColor: '#fff',
    marginBottom: 4,
  },
  qliklogo: {
    alignSelf: 'center',
    width: '200px',
    textAlign: 'right',
  },
  qlik: {
    height: 50,
  },
  // NAVIGATION BAR

  footer: {
    // backgroundColor: '#F4F5F0',
    display: 'flex',
    justifyContent: 'space-around',
    flexFlow: 'row wrap',
    borderTop: '1px solid #F4F5F0',
    backgroundImage: 'url(assets/background_header.jpg)',
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
    padding: '30px 0',
    color: '#fff',
  },
};

export default styles;
